
import { PersonalPlanSelector } from "./PersonalPlanSelector";
import { SetData } from "../types";

interface PersonalPlanControlsProps {
  exerciseId: string;
  sets: number;
  setRestTime: number;
  exerciseRestTime: number;
  setData: SetData[];
  reps: number;
  weight: number;
  onSetsChange: (value: string) => void;
  onSetRestTimeChange: (value: string) => void;
  onExerciseRestTimeChange: (value: string) => void;
  onSetDataChange: (setIndex: number, field: 'reps' | 'weight', value: string) => void;
}

export const PersonalPlanControls = ({
  exerciseId,
  sets,
  setRestTime,
  exerciseRestTime,
  setData,
  reps,
  weight,
  onSetsChange,
  onSetRestTimeChange,
  onExerciseRestTimeChange,
  onSetDataChange
}: PersonalPlanControlsProps) => {
  return (
    <div className="space-y-4">
      <PersonalPlanSelector
        exerciseId={exerciseId}
        sets={sets}
        setRestTime={setRestTime}
        exerciseRestTime={exerciseRestTime}
        setData={setData}
        reps={reps}
        weight={weight}
        onSetsChange={onSetsChange}
        onSetRestTimeChange={onSetRestTimeChange}
        onExerciseRestTimeChange={onExerciseRestTimeChange}
        onSetDataChange={onSetDataChange}
      />
    </div>
  );
};
